import { auth } from './firebase';


export const CheckToken = async() => {
  const user = auth.currentUser;

  if (!user) {
    return false;
  }

  // Get ID token info
  const tokenResult =  user.getIdTokenResult();

  const expiryTime = new Date(tokenResult.expirationTime ).getTime(); // in ms
  const now = Date.now();

  if (now > expiryTime) {
    return false;
  }
return true;
  
};
